import Header from './Header';

export { Header };



// WEBPACK FOOTER //
// ./src/components/ProductPage/components/index.js